import axios from "axios";
import * as _ from "lodash";
import { useState, useContext, useEffect, useRef } from "react";
import next from "../Assets/Next.svg";
import { useNavigate } from "react-router";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import ContestTerms from "../ContestDescripion/ContestTerms";
import ReactPlayer from "react-player";
import styles from "./UploadFormNew.module.css";
import Lottie from "../../Components/lottie/finalupload/finalUploadloading";
import deleteOpen from "../../assests/popup/deleteOpen.svg";
import { validate } from "../../utils/formAttributesHelper";
import QuizQuestions from "../QuizQuestions/QuizQuestions";
import UploadErrorPopup from "../UploadErrorPopup/UploadEroorPopup";
import CountDownWithMinutes from "../CountDownWithMinutes/CountDownWithMinutes";
import AutoSubmitPopup from "../AutoSubmitPopup/AutoSubmitPopup";
import PopupWrapper from "../../Layout/PopupWrapper";
import Prediction from "../Prediction/Prediction";
import backButtonArrow from "../../assests/backButtonArrow.svg";
import predictIcon from "../../assests/PredictWinners.png";
function UploadFormNew({
  uploadGoviralMedias,
  contestDetails,
  formDetails,
  setFormDetails,
  setThumbnail,
  loading,
  quizQuestions,
  defaultThumbnail,
  setDefaultThumbnail,
  uploadFlow2,
  setOtherMedias,
  youtubeLinks,
  patchDetails,
  extractedFrameThumbnail,
}) {
  const [errorMessage, setErrorMessage] = useState({});
  const [uploadStart, setUploadStart] = useState(false);
  const [tc, setTc] = useState(false);
  const [quizReadOnly, setQuizReadOnly] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const inputRef = useRef();
  const mediaRef = useRef();
  const [source, setSource] = useState();
  const [mediaSource, setMediaSource] = useState({});
  const [thumbnailName, setThumbnailName] = useState("");
  const [showCancel, setShowCancel] = useState(false);
  const [placeholderText, setPlaceHolderText] = useState("");
  const [startQuiz, setStartQuiz] = useState(false);
  const [startPrediction, setStartPrediction] = useState(false);
  const {
    data,
    details,
    setUploadSucccess,
    terms,
    uploadSuccessFile,
    setUploadSucccessFile,
    pinData,
    isPrivate,
    campaignType,
    generatedPosterUrl,
    handleUserTracking,
  } = useContext(Context);

  const navigate = useNavigate();
  const contestIdData = window.location.pathname.split("/")[3];
  const campaignIdData = window.location.pathname.split("/")[2];
  const organizerUniqueText = window.location.pathname.split("/")[1];
  const organizerMail = details?.conductedBy?.email;
  const [intervalId, setIntervalId] = useState(null);
  const [submitPoup, setSubmitPopup] = useState(false);
  const campaignId = contestDetails?.campaignId;
  const contestId = contestDetails?.contestId;
  const organizerId = contestDetails?.orgId;
  const formAttributes = contestDetails?.formAttributes;
  const orginizerName = window.location.pathname.split("/")[1];
  const campaignName = window.location.pathname.split("/")[2];
  const [uploadErrorPopup, setUploadErrorPopup] = useState(false);
  const [errorData, setErrorData] = useState({});
  useEffect(() => {
    if (campaignType == "DA_PAID") {
      setPlaceHolderText("About my guru and about my choreography");
    } else if (campaignType == "MOV") {
      setPlaceHolderText("");
    }
  }, [campaignType]);

  useEffect(() => {
    if (startQuiz) {
      window.scrollTo(0, 0);
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "unset";
      };
    }
  }, [startQuiz]);

  const handleFileChange = async (event) => {
    const thumbnail = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    thumbnail.append("thumbnail", file);
    setSource(url);
    setThumbnail(file);
    setThumbnailName(file.name);
  };
  const resetSource = () => {
    setSource("");
  };

  const handleChoose = async () => {
    inputRef.current.click();
  };

  const handleFileChangeMedia = (event) => {
    const fieldName = event.currentTarget.id;
    const thumbnail = new FormData();
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    thumbnail.append("thumbnail", file);
    setMediaSource((prev) => ({
      ...prev,
      [fieldName]: { url, type: file?.type },
    }));
    setOtherMedias((prev) => ({ ...prev, [fieldName]: file }));
  };

  const handleChooseMedia = async (e) => {
    mediaRef[e.currentTarget.id].click();
  };
  const resetMediaSource = (event) => {
    const fieldName = event.currentTarget.id;
    setMediaSource((prev) => {
      const newMediaSource = { ...prev };
      delete newMediaSource[fieldName];
      return newMediaSource;
    });
    setOtherMedias((prev) => {
      const newOtherMedias = { ...prev };
      delete newOtherMedias[fieldName];
      return newOtherMedias;
    });
  };

  const promiseUploadCall = async (e) => {
    e?.preventDefault();
    let errors = {};
    setDefaultThumbnail(false);
    setUploadErrorPopup(false);
    let defaultThumbnailType = false;
    if (_.isEmpty(thumbnailName) && contestDetails?.fileType === "video") {
      setDefaultThumbnail(true);
      defaultThumbnailType = true;
      // errors.thumbnailName = "Please upload a cover image";
      // setErrorData({
      //   error: `Please upload a cover image`,
      //   description: `You have not added the cover photo for this performance , Giving a cover photo will make your entry more beautiful
      //   - please upload your own photo or the photo of performance.`,
      // });
      // setUploadErrorPopup(true);
    }
    
    if (extractedFrameThumbnail && contestDetails?.fileType === "video") {
      setDefaultThumbnail(false);
      defaultThumbnailType = false;
    }

    if (_.isEmpty(thumbnailName) && contestDetails?.fileType === "audio") {
      errors.thumbnailName = "Please upload a participant image";
      setErrorData({
        error: `Please upload a participant image`,
        description: `You have not added the participant image for this performance , Giving a participant image will make your entry more beautiful
        - please upload your own photo or the photo of performance.`,
      });
      setUploadErrorPopup(true);
    }
    if (
      _.isEmpty(formDetails?.participantName) ||
      formDetails?.participantName?.length === 0
    ) {
      errors.participantName = "Please enter the display name";
      setErrorData({
        error: `You have not entered your name`,
        description: details?.certificate
          ? `You have a Participation Signature certificate for this contest. This name will be displayed on the certificate.`
          : "This name will be displayed on your entry.",
      });
      setUploadErrorPopup(true);
    }
    if (!formDetails.tc) {
      errors.tc = "Please accept the terms and conditions";
      setErrorData({
        error: `Please accept the terms and conditions`,
      });
      setUploadErrorPopup(true);
    }
    let verifyFormAttributes = false;
    if (formAttributes) {
      verifyFormAttributes = await validate(
        formAttributes,
        formDetails,
        mediaSource,
        errors,
        setUploadErrorPopup,
        setErrorData,
      );
    }

    setErrorMessage(errors);
    let cmpId = campaignId;
    let ctstId = contestId;
    let orgId = organizerId;

    if (_.isEmpty(errors)) {
      if (generatedPosterUrl) {
        if (contestDetails?.isFaceSwap) {
          await uploadGoviralMedias();
        } else {
          await uploadFlow2(cmpId, ctstId, orgId, "", "poster");
        }
      } else if (!_.isEmpty(youtubeLinks)) {
        await patchDetails(defaultThumbnailType);
      } else {
        await uploadGoviralMedias();
      }
    }
    //end of process

    // await uploadFlow2(pinData.data.data.videoId, cmpId, ctstId, orgId);
    // if (contestDetails?.fileType === "video") {
    //   await thubnailUpload(pinData.data.data.videoId, cmpId, ctstId, orgId);
    // }
  };

  const handleCancel = () => {
    setShowCancel(true);
  };
  const [answers, setAnswers] = useState([]);

  const handleAnswerSelect = (questionId, image, question, selectedAnswer) => {
    const existingAnswerIndex = answers.findIndex(
      (answer) => answer.questionId === questionId,
    );

    if (existingAnswerIndex !== -1) {
      const updatedAnswers = [...answers];
      updatedAnswers[existingAnswerIndex] = {
        questionId: questionId,
        answer: selectedAnswer,
        image,
        question,
      };
      setAnswers(updatedAnswers);
      setFormDetails((prevState) => ({
        ...prevState,
        answers: updatedAnswers,
      }));
    } else {
      setAnswers([
        ...answers,
        { questionId: questionId, answer: selectedAnswer, image, question },
      ]);
      setFormDetails((prevState) => ({
        ...prevState,
        answers: [
          ...answers,
          { questionId: questionId, answer: selectedAnswer, image, question },
        ],
      }));
    }
  };

  const handlePredictionSelect = (index, id, prediction) => {
    setFormDetails((prevState) => {
      let newPrediction = prevState?.predictions || [];
      let newObject = newPrediction[index] || {};
      if (_.isEmpty(newObject)) {
        newObject = { id, prediction };
        newPrediction.push(newObject);
      } else {
        newObject = { id, prediction };
        newPrediction[index] = newObject;
      }

      return { ...prevState, predictions: newPrediction };
    });
  };

  const handleTimeOut = () => {
    setSubmitPopup(true);
    setStartQuiz(false);
    clearInterval(intervalId);
  };
  const validateDetails = async () => {
    let errors = {};
    setDefaultThumbnail(false);
    setUploadErrorPopup(false);
    if (
      _.isEmpty(formDetails?.participantName) ||
      formDetails?.participantName?.length === 0
    ) {
      errors.participantName = "Please enter the display name";
      setErrorData({
        error: `You have not entered your name`,
        description: details?.certificate
          ? `You have a Participation Signature certificate for this contest. This name will be displayed on the certificate.`
          : "This name will be displayed on your entry.",
      });
      setUploadErrorPopup(true);
    }
    if (!formDetails.tc) {
      errors.tc = "Please accept the terms and conditions";
      setErrorData({
        error: `Please accept the terms and conditions`,
      });
      setUploadErrorPopup(true);
    }
    let verifyFormAttributes = false;
    if (formAttributes) {
      verifyFormAttributes = await validate(
        formAttributes,
        formDetails,
        mediaSource,
        errors,
        setUploadErrorPopup,
        setErrorData,
      );
    }
    return errors;
  };

  const handleStartQuiz = async () => {
    setQuizReadOnly(false);
    const errors = await validateDetails();
    setErrorMessage(errors);
    if (_.isEmpty(errors)) {
      setStartQuiz(true);
    } else {
      setQuizReadOnly(true);
    }
  };
  const handleStartPrediction = async () => {
    const errors = await validateDetails();
    setErrorMessage(errors);
    if (_.isEmpty(errors)) {
      setStartPrediction(true);
    }
  };

  const handleAutoSubmit = () => {
    setSubmitPopup(false);
    window.scrollTo(0, document.body.scrollHeight);
    promiseUploadCall();
  };
  return (
    <>
      {uploadErrorPopup && (
        <UploadErrorPopup
          errorData={errorData}
          setUploadErrorPopup={setUploadErrorPopup}
          backgroundColor={contestDetails?.buttonColor}
        />
      )}
      {submitPoup && (
        <AutoSubmitPopup
          handleSubmit={handleAutoSubmit}
          backgroundColor={contestDetails?.buttonColor}
        />
      )}
      <div className="w-[100%] relative pb-[5px]">
        <div className="mt-[30px]">
          <div className={styles.uploadForm}>
            {contestDetails?.fileType === "video" && (
              <div className="flex flex-col  mt-[20px]">
                <label htmlFor="participantName" className=" ">
                  Add Cover Image
                </label>
                <div className="w-[100%]">
                  <span className="text-[#B5B5B5]  text-smallest">
                    Allowed file types are .jpeg and .jpg only. Can be any image
                    to showcase the video.
                  </span>
                </div>
                <input
                  ref={inputRef}
                  className="hidden"
                  type="file"
                  onChange={handleFileChange}
                  accept=".jpg,.jpeg"
                />
                <div className="flex w-full justify-center mt-[10px]">
                  {source ? (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                          <img src={source} className="w-auto h-[100%]" />
                        </div>
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Replace Cover Image
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                          <img
                            src={
                              extractedFrameThumbnail ||
                              details?.defaultThumbnail
                            }
                            className="w-auto h-[100%]"
                          />
                        </div>
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Replace Default Cover Image
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {errorMessage?.thumbnailName && (
                  <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                    {errorMessage?.thumbnailName}
                  </p>
                )}
              </div>
            )}
            {contestDetails.fileType?.startsWith("audio") && (
              <div className="flex flex-col  mt-[20px]">
                <label htmlFor="participantName" className=" ">
                  Add Participant Image{" "}
                  <span className="text-[#FA6B6B]">*</span>
                </label>
                <div className="w-[100%]">
                  <span className="text-[#B5B5B5]  text-smallest">
                    Can be any image to showcase the video.
                  </span>
                </div>
                <input
                  ref={inputRef}
                  className="hidden"
                  type="file"
                  onChange={handleFileChange}
                  accept="image/*"
                />
                <div className="flex w-full justify-center mt-[10px]">
                  {source ? (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                          <img src={source} className="w-auto h-[100%]" />
                        </div>
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Replace Participant Image
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                      onClick={handleChoose}
                    >
                      <div>
                        <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]"></div>
                        <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                          Upload Participant Image
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {errorMessage?.thumbnailName && (
                  <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                    {errorMessage?.thumbnailName}
                  </p>
                )}
              </div>
            )}
            <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
              <label htmlFor="participantName">
                Participant Name <span className="text-[#FA6B6B]">*</span>
              </label>
              <input
                type="text"
                id="participantName"
                name="participantName"
                placeholder={
                  details?.certificate &&
                  "This name will be displayed on the certificate."
                }
                value={formDetails.participantName}
                onChange={(e) =>
                  setFormDetails({
                    ...formDetails,
                    participantName: e.target.value,
                  })
                }
                className={errorMessage?.participantName ? styles.error : ""}
              />
              {errorMessage?.participantName && (
                <p className="text-[#FA6B6B] text-smallest ">
                  {errorMessage?.participantName}
                </p>
              )}
              {details?.certificate && (
                <p className=" text-smallest text-[#B5B5B5]">
                  This name will be displayed on the certificate.
                </p>
              )}
            </div>

            {formAttributes?.map((el) => {
              if (el.attrType == "scoring") {
                return (
                  <div className="flex flex-col gap-[10px] mt-[30px]">
                    <label
                      className=" text-regular"
                      style={{
                        color: formDetails.property ? "#787878" : "#ffffff",
                      }}
                    >
                      {el.title}{" "}
                      {el.required && <span className="text-[#FA6B6B]">*</span>}
                    </label>
                    {el.items.map((key) => {
                      return (
                        <>
                          {/* <h1 className="text-[#B5B5B5]">{key}</h1> */}
                          {el?.fieldType == "textfield" ? (
                            <textarea
                              type={el.type}
                              min="0"
                              value={formDetails.property}
                              placeholder={el?.placeHolder}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  [el.property[key]]: e.target.value,
                                })
                              }
                              className={
                                errorMessage[el.property[key]]
                                  ? styles.error
                                  : ""
                              }
                            />
                          ) : (
                            <input
                              type={el.type}
                              min="0"
                              value={formDetails[el.property[key]]}
                              placeholder={el?.placeHolder}
                              onChange={(e) =>
                                setFormDetails({
                                  ...formDetails,
                                  [el.property[key]]: e.target.value,
                                })
                              }
                              className={
                                errorMessage[el.property[key]]
                                  ? styles.error
                                  : ""
                              }
                            />
                          )}
                          {errorMessage[el.property[key]] && (
                            <p className="text-[#FA6B6B] text-smallest ">
                              {errorMessage[el.property[key]]}
                            </p>
                          )}
                        </>
                      );
                    })}
                  </div>
                );
              } else if (el.attrType == "prediction") {
                return (
                  <div className="flex flex-col gap-[10px] mt-[20px]">
                    <label className="text-regular ">
                      {el.title}
                      {el.required && <span className="text-[#FA6B6B]">*</span>}
                    </label>
                    <select
                      onChange={(e) =>
                        setFormDetails({
                          ...formDetails,
                          [el.property.key]: e.target.value,
                        })
                      }
                      className=""
                    >
                      <option selected disabled>
                        select an option
                      </option>
                      {el.items.map((key) => {
                        return (
                          <>
                            <option className="">{key}</option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                );
              } else if (el.attrType == "media") {
                return (
                  <div className="flex flex-col gap-[10px] mt-[30px]">
                    <label className="text-regular ">
                      {el.title}
                      {el.required && <span className="text-[#FA6B6B]">*</span>}
                    </label>
                    {el?.items?.map((key) => {
                      return (
                        <div>
                          <div className="w-[100%]">
                            <span className="text-[#B5B5B5]  text-smallest">
                              {el?.placeHolder}
                            </span>
                          </div>
                          <input
                            ref={(element) => {
                              mediaRef[el?.property[key]] = element;
                            }}
                            className="hidden"
                            type="file"
                            onChange={handleFileChangeMedia}
                            accept={el?.fieldType}
                            id={el?.property[key]}
                          />
                          <div className="flex w-full justify-center mt-[10px]">
                            {mediaSource[el?.property[key]] ? (
                              <div
                                className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                                onClick={(e) => e.stopPropagation()}
                                id={el?.property[key]}
                              >
                                <div>
                                  {mediaSource[
                                    el?.property[key]
                                  ]?.type?.startsWith("image") && (
                                    <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                      <img
                                        src={mediaSource[el?.property[key]].url}
                                        className="w-auto h-[100%]"
                                      />
                                    </div>
                                  )}
                                  {mediaSource[
                                    el?.property[key]
                                  ]?.type?.startsWith("video") && (
                                    <div className="h-[320px] h-auto w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                                      <ReactPlayer
                                        playing={false}
                                        controls={true}
                                        width="100%"
                                        height="100%"
                                        url={mediaSource[el?.property[key]].url}
                                        style={{ objectFit: "contain" }}
                                      />
                                    </div>
                                  )}
                                  <div className="flex gap-[30px] items-center justify-center">
                                    <button
                                      className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit "
                                      onClick={handleChooseMedia}
                                      id={el?.property[key]}
                                    >
                                      Replace
                                    </button>
                                    <button
                                      className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit "
                                      onClick={resetMediaSource}
                                      id={el?.property[key]}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="w-[100%] min-h-[60px]  overflow-hidden text-center cursor-pointer text-white focus:outline-0  font-Inter font-[400] text-[17px] leading-[24px]"
                                onClick={handleChooseMedia}
                                id={el?.property[key]}
                              >
                                <div>
                                  <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                    <button className="text-small text-[#8B8B8B] bg-[#252525] rounded-[6px] py-[8px] px-[17px] mt-[10px] w-fit mx-auto">
                                      Upload {el?.type}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          {errorMessage[key] && (
                            <p className="text-[#FA6B6B] text-smallest mt-[5px]">
                              {errorMessage[key]}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              }
            })}
            {contestDetails?.displayPlaceHolder && (
              <>
                <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                  <label htmlFor="description">Share your thoughts</label>
                  <div className="relative flex">
                    <textarea
                      type="text"
                      id="description"
                      name="description"
                      // maxLength="120"
                      value={formDetails.description}
                      placeholder={contestDetails?.displayPlaceHolder}
                      onChange={(e) =>
                        setFormDetails({
                          ...formDetails,
                          description: e.target.value,
                        })
                      }
                      className={errorMessage?.description ? styles.error : ""}
                    />
                    {/* <span className="text-white w-[98%] absolute flex bottom-2 justify-end opacity-[.6]">
                    {formDetails?.description?.length}/120
                  </span> */}
                  </div>
                  {errorMessage?.description && (
                    <p className="text-[#FA6B6B] text-smallest ">
                      {errorMessage?.description}
                    </p>
                  )}
                </div>
              </>
            )}

            {/* End */}
            <div className=" mt-[25px] mb-[24px]">
              <div className="flex  items-center justify-start   gap-[10px]">
                <input
                  type="checkbox"
                  id="tc"
                  name="tc"
                  value={formDetails.tc}
                  // checked={true}
                  onClick={() =>
                    setFormDetails({
                      ...formDetails,
                      tc: !formDetails.tc,
                    })
                  }
                  className="w-[30px] h-[30px] rounded-[5px] focus:outline-none "
                />
                <label
                  htmlFor="tc"
                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px]"
                >
                  I agree to the{" "}
                </label>
                <a
                  onClick={() => setShowTerms(true)}
                  className="text-[#B5B5B5] font-Inter font-[400] text-[17px] leading-[24px] underline  underline-offset-1 cursor-pointer"
                >
                  Terms And Conditions
                </a>
              </div>

              {errorMessage?.tc && (
                <p className="text-[#FA6B6B] text-smallest mt-[12px]">
                  {errorMessage?.tc}
                </p>
              )}
            </div>

            {!_.isEmpty(quizQuestions) && (
              <div className="mb-[30px]">
                <p className="mt-[30px] text-large-bold">Quiz</p>
                {startQuiz ? (
                  <div className="widthController z-20 relative">
                    <PopupWrapper>
                      <div className="fixed top-0 left-0 w-full h-full z-[102]">
                        <div className="overflow-auto no-scrollbar h-full w-full max-w-[425px] mx-auto bg-black px-[20px] py-[40px]">
                          <div className="sticky w-full bg-black top-[-40px] z-[103] flex items-center justify-between py-[12px]">
                            <div>
                              {contestDetails?.timeLimit && (
                                <div className="w-fit mx-auto">
                                  <CountDownWithMinutes
                                    time={contestDetails?.timeLimit}
                                    buttonColor={contestDetails?.buttonColor}
                                    handleSubmit={handleTimeOut}
                                    setIntervalId={setIntervalId}
                                    setQuizReadOnly={setQuizReadOnly}
                                  />
                                </div>
                              )}
                            </div>
                            <button
                              onClick={(e) => {
                                clearInterval(intervalId);
                                promiseUploadCall(e);
                                setStartQuiz(false);
                                handleUserTracking(e.currentTarget.id);
                              }}
                              id={`NB_${contestDetails?.contestId}`}
                              type="submit"
                              className="commonButton text-regular-medium"
                              disabled={loading}
                              style={{
                                backgroundColor: contestDetails?.buttonColor,
                              }}
                            >
                              Submit
                            </button>
                          </div>
                          {quizQuestions?.map((obj, index) => {
                            return (
                              <QuizQuestions
                                question={obj}
                                key={index}
                                number={index}
                                onAnswerSelect={handleAnswerSelect}
                                quizReadOnly={quizReadOnly}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </PopupWrapper>
                  </div>
                ) : (
                  <div className=" bg-[#1c1c1c] p-[10px] mt-[24px]">
                    <p className="text-small mb-[10px] text-[#B5B5B5]">
                      Once the quiz starts, you cannot go back.
                    </p>
                    {contestDetails?.timeLimit && (
                      <p className="text-small mb-[20px] text-[#B5B5B5]">
                        You will have {contestDetails?.timeLimit} minutes to
                        complete the quiz.
                      </p>
                    )}
                    <button
                      onClick={handleStartQuiz}
                      className="commonButton text-regular-medium mx-auto "
                      disabled={loading}
                      style={{
                        backgroundColor: contestDetails?.buttonColor,
                      }}
                    >
                      Start Quiz
                    </button>
                  </div>
                )}
              </div>
            )}
            {contestDetails?.contestType == "WPM" && (
              <div className="mb-[30px]">
                <p className="mt-[30px] text-large-bold">Prediction</p>
                {startPrediction ? (
                  <div className="widthController z-20 relative">
                    <PopupWrapper>
                      <div className="fixed top-0 left-0 w-full h-full z-[102]">
                        <div className="overflow-auto no-scrollbar h-full w-full max-w-[425px] mx-auto bg-black px-[20px] pb-[40px]">
                          <div className="sticky w-full bg-black top-0 z-[103] flex items-center justify-between py-[12px]">
                            <div>
                              {/* need popups for showing submitted message  */}
                              <div
                                className="icon-bg relative  hover:cursor-pointer dismissButton z-[1] flex items-center justify-center"
                                onClick={() => {
                                  clearInterval(intervalId);
                                  setStartPrediction(false);
                                }}
                              >
                                <img
                                  src={backButtonArrow}
                                  alt=""
                                  className=""
                                />
                              </div>
                              {/* {contestDetails?.timeLimit && (
                                <div className="w-fit mx-auto">
                                  <CountDownWithMinutes
                                    time={contestDetails?.timeLimit}
                                    buttonColor={contestDetails?.buttonColor}
                                    handleSubmit={handleTimeOut}
                                    setIntervalId={setIntervalId}
                                    setQuizReadOnly={setQuizReadOnly}
                                  />
                                </div>
                              )} */}
                            </div>

                            <button
                              onClick={(e) => {
                                clearInterval(intervalId);
                                promiseUploadCall(e);
                                setStartPrediction(false);
                                handleUserTracking(e.currentTarget.id);
                              }}
                              id={`NB_${contestDetails?.contestId}`}
                              type="submit"
                              className="commonButton text-regular-medium"
                              disabled={loading}
                              style={{
                                backgroundColor: contestDetails?.buttonColor,
                              }}
                            >
                              Submit
                            </button>
                          </div>
                          <img
                            src={predictIcon}
                            className="mx-auto w-fit my-[16px]"
                          />
                          <p className="text-smallest2 uppercase text-center w-full mb-[24px]">
                            Tap or click any team to predict as winners
                          </p>
                          {contestDetails?.matchDetails?.map((obj, index) => {
                            if (obj?.status !== "CLOSED") {
                              return (
                                <Prediction
                                  question={obj}
                                  key={index}
                                  number={index}
                                  onAnswerSelect={handlePredictionSelect}
                                />
                              );
                            }
                          })}
                          {contestDetails?.matchDetails?.map((obj, index) => {
                            if (obj?.status == "CLOSED") {
                              return (
                                <Prediction
                                  question={obj}
                                  key={index}
                                  number={index}
                                  onAnswerSelect={handlePredictionSelect}
                                />
                              );
                            }
                          })}
                        </div>
                      </div>
                    </PopupWrapper>
                  </div>
                ) : (
                  <div className=" bg-[#1c1c1c] p-[10px] mt-[24px]">
                    <p className="text-small mb-[10px] text-[#B5B5B5]">
                      Click the button below and Start Predicting
                    </p>
                    {contestDetails?.timeLimit && (
                      <p className="text-small mb-[20px] text-[#B5B5B5]">
                        You will have {contestDetails?.timeLimit} minutes to
                        complete the prediction.
                      </p>
                    )}
                    <button
                      onClick={handleStartPrediction}
                      className="commonButton text-regular-medium mx-auto "
                      disabled={loading}
                      style={{
                        backgroundColor: contestDetails?.buttonColor,
                      }}
                    >
                      Start Prediction
                    </button>
                  </div>
                )}
              </div>
            )}
            {/* {errorMessage && (
              <p className="text-[#8B0000] text-[18px] mt-[21px] mb-[24px]">
                {errorMessage}
              </p>
            )} */}
            {!contestDetails?.contestType?.startsWith("QUIZ") &&
              contestDetails?.contestType !== "WPM" && (
                <div className="flex items-center justify-between gap-[20px] w-[100%]   ">
                  {" "}
                  <button
                    className=" text-[#FA6B6B] w-full text-regular border-[1px] border-[#FA6B6B] rounded-[6px] px-[32px] py-[9px]"
                    onClick={(e) => {
                      handleUserTracking(e.currentTarget.id);
                      handleCancel();
                    }}
                    id={`CB_${contestDetails?.contestId}`}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={(e) => {
                      clearInterval(intervalId);
                      promiseUploadCall(e);
                      handleUserTracking(e.currentTarget.id);
                    }}
                    id={`NB_${contestDetails?.contestId}`}
                    type="submit"
                    className="commonButton text-regular-medium"
                    disabled={loading}
                    style={{
                      backgroundColor: contestDetails?.buttonColor,
                    }}
                  >
                    Next
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
      {showTerms && (
        <ContestTerms
          terms={details?.tandc}
          setShowDetails={setShowTerms}
          heading={"Terms and Conditions"}
        />
      )}
      {showCancel && (
        <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center">
          <div className={styles.deteleme}>
            <img
              src={deleteOpen}
              alt=""
              className="w-[56px] h-[56px] mb-[24px]"
            />
            <p className="text-regular-medium px-[20px] mb-[16px]">
              Are you sure want to restart upload?
            </p>
            <p className="text-small text-[#CDCDCD] px-[20px]">
              You can’t undo this action.
            </p>
            <div className="seperator my-[20px]" />
            <div className="flex flex-col gap-[16px] w-[100%]">
              <button
                className={styles.Deeleeete}
                onClick={() =>
                  navigate(
                    `/${organizerUniqueText}/${campaignIdData}/${contestIdData}`,
                  )
                }
              >
                <p className="text-regular-medium">Yes</p>
              </button>
              <button
                className={styles.cancelDelete}
                onClick={() => setShowCancel(false)}
              >
                <p className="text-regular-medium">Cancel</p>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UploadFormNew;
